/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.config.getEnv";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"playbackWorkerUrl":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"gamesEnabled":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean())});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get client-facing environment configuration from the server. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
